import { memo } from 'react';

import File from './File.tsx';
import { MultiFileList } from './MultiFileList.tsx';
import type { FileUploadProps } from './types.ts';

export const FileList = memo(function FileList({
  error,
  isUploading,
  success,
  fileName,
  filesState,
  multi,
  progress,
  handleReset,
  tryAnotherText,
}: FileUploadProps) {
  if (!multi) {
    return (
      fileName && (
        <File
          fileName={fileName}
          progress={progress}
          handleReset={handleReset}
          tryAnotherText={tryAnotherText}
          isUploading={isUploading}
          error={error}
          success={success}
        />
      )
    );
  }

  return <MultiFileList filesState={filesState} tryAnotherText={tryAnotherText} handleReset={handleReset} />;
});
